import React from "react";

export function CategorySkeleton() {
  return (
    <div className="mg-category-skeletons" aria-label="Loading fitness categories">
      {[0, 1, 2, 3, 4, 5].map((item) => (
        <div className="mg-category-skeleton" key={item}>
          <div className="mg-skeleton mg-category-skeleton__image"></div>
          <div className="mg-skeleton mg-category-skeleton__label"></div>
        </div>
      ))}
    </div>
  );
}

export function GymDiscoverySkeleton({ count = 4 }) {
  return (
    <div className="mg-discovery-skeletons" aria-label="Loading fitness centres">
      {Array.from({ length: count }, (_, item) => (
        <div className="mg-discovery-skeleton" key={item}>
          <div className="mg-skeleton mg-discovery-skeleton__image"></div>
          <div className="mg-skeleton mg-discovery-skeleton__title"></div>
          <div className="mg-skeleton mg-discovery-skeleton__location"></div>
          <div className="mg-skeleton mg-discovery-skeleton__tag"></div>
        </div>
      ))}
    </div>
  );
}
